var map = {
	"./base-init.conf.ts": 9308,
	"./baseConfiguration.ts": 1285,
	"./baseSelectorConfiguration.ts": 19098,
	"legacy/customer/base/losteria/base-init.conf.ts": 9308,
	"legacy/customer/base/losteria/baseConfiguration.ts": 1285,
	"legacy/customer/base/losteria/baseSelectorConfiguration.ts": 19098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55371;